import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { OfficeAction, VehicleAction } from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    authOfficeId: PropTypes.number,
    authOfficeName: PropTypes.string,
    createVehicle: PropTypes.func,
    editVehicle: PropTypes.func,
    getOffices: PropTypes.func,
    getVehicle: PropTypes.func,
    offices: PropTypes.arrayOf(PropTypes.object),
    vehicle: PropTypes.object,
    vehicleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.vehicle);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.vehicleId) {
      this.props.getVehicle(this.props.vehicleId);
    }
  }

  componentDidUpdate(props, _state, _snapshot) {
    if (JSON.stringify(props.vehicle) !== JSON.stringify(this.props.vehicle)) {
      this.setState({ ...this.getInitialState(this.props.vehicle) });
    }
  }

  getInitialState(vehicle) {
    const officeId = [this.props.authOfficeId, vehicle?.office_id, '']?.find?.(
      i => i,
    );
    const officeSelected = [
      this.props.authOfficeId && {
        label: this.props.authOfficeName,
        value: this.props.authOfficeId,
      },
      vehicle?.office?.id && {
        label: vehicle?.office?.name,
        value: vehicle?.office?.id,
      },
      '',
    ]?.find?.(i => i);
    return {
      class: vehicle?.class || '',
      cylinder_cc: vehicle?.cylinder_cc || '',
      horse_power: vehicle?.horse_power || '',
      laden_weight: vehicle?.laden_weight || '',
      maker_name: vehicle?.maker_name || '',
      manufacture_year: vehicle?.manufacture_year || new Date().getFullYear(),
      model: vehicle?.model || '',
      office_id: officeId || '',
      office_selected: officeSelected || '',
      seating_capacity: vehicle?.seating_capacity || '',
      tyre_size: vehicle?.tyre_size || '',
      wheel_base: vehicle?.wheel_base || '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSelect(option, action) {
    const { _name, name } = action;
    const { value } = option;
    this.setState({ [name]: option, [_name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.vehicleId) {
      this.props.editVehicle(this.props.vehicleId, this.state);
    } else {
      this.props.createVehicle(this.state);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.vehicleId ? 'Edit' : 'Create'} Vehicle
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                {!this.props.authHasOffice && (
                  <div className="form-row">
                    <div className="form-group col">
                      <label htmlFor="office_id">Office</label>
                      <Select
                        id="office_id"
                        isDisabled={this.props.authHasOffice}
                        name="office_selected"
                        onChange={(option, action) =>
                          this.onSelect(option, {
                            ...action,
                            _name: 'office_id',
                          })
                        }
                        onInputChange={value => {
                          value && this.props.getOffices({ query: value });
                        }}
                        options={this.props.offices}
                        placeholder="Select Office"
                        value={this.state.office_selected}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="model">Model/Make of Vehicle</label>
                    <input
                      className="form-control"
                      id="model"
                      name="model"
                      onChange={this.onChange}
                      placeholder="Model/Make of Vehicle"
                      type="text"
                      value={this.state.model}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="class">Class of Vehicle</label>
                    <input
                      className="form-control"
                      id="class"
                      name="class"
                      onChange={this.onChange}
                      placeholder="Class of Vehicle"
                      type="text"
                      value={this.state.class}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="cylinder_cc">
                      Number of Cylinder with CC
                    </label>
                    <input
                      className="form-control"
                      id="cylinder_cc"
                      name="cylinder_cc"
                      onChange={this.onChange}
                      placeholder="Number of Cylinder with CC"
                      type="text"
                      value={this.state.cylinder_cc}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="tyre_size">Size of Tyre</label>
                    <input
                      className="form-control"
                      id="tyre_size"
                      name="tyre_size"
                      onChange={this.onChange}
                      placeholder="Size of Tyre"
                      type="text"
                      value={this.state.tyre_size}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="manufacture_year">
                      Year of Manufacture/Assemble
                    </label>
                    <input
                      className="form-control"
                      id="manufacture_year"
                      name="manufacture_year"
                      onChange={this.onChange}
                      placeholder="Year of Manufacture/Assemble"
                      type="number"
                      value={this.state.manufacture_year}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="horse_power">Horse Power</label>
                    <input
                      className="form-control"
                      id="horse_power"
                      name="horse_power"
                      onChange={this.onChange}
                      placeholder="Horse Power"
                      type="text"
                      value={this.state.horse_power}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="laden_weight">Laden Weight</label>
                    <input
                      className="form-control"
                      id="laden_weight"
                      name="laden_weight"
                      onChange={this.onChange}
                      placeholder="Laden Weight"
                      type="text"
                      value={this.state.laden_weight}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="wheel_base">Wheel Base</label>
                    <input
                      className="form-control"
                      id="wheel_base"
                      name="wheel_base"
                      onChange={this.onChange}
                      placeholder="Wheel Base"
                      type="text"
                      value={this.state.wheel_base}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="seating_capacity">Seating Capacity</label>
                    <input
                      className="form-control"
                      id="seating_capacity"
                      name="seating_capacity"
                      onChange={this.onChange}
                      placeholder="Seating Capacity"
                      type="text"
                      value={this.state.seating_capacity}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-4">
                    <label htmlFor="maker_name">Maker's Name</label>
                    <input
                      className="form-control"
                      id="maker_name"
                      name="maker_name"
                      onChange={this.onChange}
                      placeholder="Maker's Name"
                      type="text"
                      value={this.state.maker_name}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  authHasOffice: !!state?.auth?.office,
  authOfficeId: state?.auth?.office?.id,
  authOfficeName: state?.auth?.office?.name,
  offices: state?.office?.list?.data?.map?.(row => ({
    label: row.name,
    value: row.id,
  })),
  vehicle: state?.vehicle?.detail,
  vehicleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  createVehicle: data => dispatch(VehicleAction.createVehicle(data)),
  editVehicle: (id, data) => dispatch(VehicleAction.editVehicle(id, data)),
  getOffices: params => dispatch(OfficeAction.getOffices(params)),
  getVehicle: id => dispatch(VehicleAction.getVehicle(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
